import { message } from 'antd';
import isEmpty from 'lodash/isEmpty';

export default {
  defaultCustomSearchValue: '',
  catchApiError: (result, routing) => {
    return new Promise((resolve, reject) => {
      if (result.status === 'false') {
        message.config({
          top: 24,
        });
        if (result.error === 402 || result.error === 403) {
          message.error("登录超时，请重新登录！");
          !!localStorage.me && localStorage.removeItem('me');
          routing.push('/login');
        } else {
          result.msg && message.error(result.msg);
          reject(result);
        }
        return;
      }
      resolve(result);
    });
  },
  transHTML(val = "") {
    let result = val
      .replace(/>/g, "&gt;")
      .replace(/</g, "&lt;")
      .replace(/\n/g, "<br/>")
      .replace(/\r/g, "<br/>")
      .replace(/\s/g, "&nbsp;")
      .replace(/'/g, "&apos;")
      .replace(/"/g, "&quot;");
    return result;
  },
  getAccessToken: () => {
    let access_token = '';
    if (!!localStorage.me) {
      let me = !!localStorage.me ? JSON.parse(localStorage.me) : { role: "" };
      access_token = me.token.access_token;
    }
    return access_token;
  },
  getTel: () => {
    let tel = '';
    if (!!localStorage.me) {
      let me = !!localStorage.me ? JSON.parse(localStorage.me) : { role: "" };
      tel = me.member ? me.member.m_mobile : '';
    }
    return tel;
  },

  getEcId: () => {
    let ecId = '';
    if (!!localStorage.me) {
      let me = !!localStorage.me ? JSON.parse(localStorage.me) : { role: "" };
      if (me.member) ecId = me.member.ec_id;
    }
    return ecId;
  },
  //判断是否客户帐号
  isCus: () => {
    let iscus = true;
    if (!!localStorage.me) {
      let me = !!localStorage.me ? JSON.parse(localStorage.me) : { role: "" };
      if (me.com && me.com === 'weaver') iscus = false;
    }
    return iscus;
  },
  isWeaver: () => {
    const isEcodeDetailPage = window.location.hash.indexOf('ecode/detail') >= 0;
    if (!!localStorage.me) {
      let me = !!localStorage.me ? JSON.parse(localStorage.me) : {};
      return !isEmpty(me) && !isEcodeDetailPage;
    }
    return false;
  },
  isMobile: () => {
    let mobile = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i);
    return mobile != null;
  },
  getRandom: (prefixCls) => `${prefixCls}_${Math.random().toString(16)}`,
  openEcode: () => {
    return true;
    // return window.location.href.indexOf('openEcode=y') >= 0;
  },
  getStringLength: (val = "") => {
    let len = 0;
    for (let i = 0; i < val.length; i++) {
      let c = val.charCodeAt(i);
      //单字节加1
      if ((c >= 0x0001 && c <= 0x007e) || (0xff60 <= c && c <= 0xff9f)) {
        len++;
      } else {
        len += 3;
      }
    }
    return len;
  },
  getStringByLength: (val = "", length) => {
    let len = 0,
      str = "";
    for (let i = 0; i < val.length; i++) {
      let c = val.charCodeAt(i);
      let s = val.charAt(i);
      //单字节加1
      if ((c >= 0x0001 && c <= 0x007e) || (0xff60 <= c && c <= 0xff9f)) {
        len++;
      } else {
        len += 3;
      }
      if (len > length) return str;
      str += s;
    }
  },
  getMiddleUrl: () => {
    // const middleUrl = 'https://clouddemo.e-cology.cn/spa/custom/static/index.html#/main/cs/app/0a8639c0cc184f529e7bb1653feed04d_middlePage';
    const middleUrl = 'https://e-cloudstore.com/spa/custom/static/index.html#/main/cs/app/0a8639c0cc184f529e7bb1653feed04d_middlePage';
    return middleUrl;
  },
}


// WEBPACK FOOTER //
// ./src/util/index.js